import { graphql } from '@/gql/graphql';

export const EventBannerScoreFragment = graphql(/* GraphQL */ `
  fragment EventBannerScore on event {
    datetime
  }
`);

export const EventBannerScoreEventTeamFragment = graphql(/* GraphQL */ `
  fragment EventBannerScoreEventTeam on event_team {
    score
  }
`);
